export const VIEW_TYPES = {
  ACADEMIC_RECOGNITION_NACID: "ACADEMIC_RECOGNITION_NACID",
  ACADEMIC_RECOGNITION_UNIVERSITIES: "ACADEMIC_RECOGNITION_UNIVERSITIES",
  PROFESSIONAL_QUALIFICATION: "PROFESSIONAL_QUALIFICATION",
};
